/* eslint-disable max-len, no-unused-vars */
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import YourSetting from './components/YourSetting';
import EventPreview from './components/EventPreview';
import ProductPreview from './components/ProductPreview';
import TotalBox from './components/TotalBox';
import EventNote from './components/EventNote';

const CreateEventStep3 = ({ goToStep }) => {
  const { watch, getValues } = useFormContext() || {};
  const formData = getValues ? getValues() : {};
  const formAdminCost = watch ? watch('adminCost') : formData.adminCost;
  const adminFee = Number(formAdminCost || 0);

  const [itemsTotal, setItemsTotal] = useState(0);

  return (
    <div className="event-hosting-step-container">
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <YourSetting onEdit={() => goToStep?.(1)} />
        <EventPreview />
        <ProductPreview onTotalChange={setItemsTotal} />
        <TotalBox itemsTotal={itemsTotal} adminFee={adminFee} />
        <EventNote />
      </div>
    </div>
  );
};

export default CreateEventStep3;
